var regularSearchHitProcessors = {};

regularSearchHitProcessors.product = function(hit) {
    var product = {};

    product.id = hit._id;
    product.title = hit.highlight && hit.highlight.title ? hit.highlight.title : hit._source.title;
    product.authorsDescription = hit.highlight && hit.highlight.authors ? hit.highlight.authors : hit._source.authors;
    product.urlFront = hit._source.urlFront;
    product.urlCover = hit._source.urlCover;
    product.prices = hit._source.prices;
    product.model = hit._source.model;
    product.language = hit._source.language ? hit._source.language : '';
    product.stateDescription = hit._source.stateDescription;
    product.description = hit._source.description;
    product.authorsUrlFront = hit._source.authorsUrlFront;
    if(hit._source.actionCategoryButton) {
        product.actionCategoryButton = hit._source.actionCategoryButton;
    } else {
        product.actionCategoryButton = '';
    }
    if(hit._source.bestSoldNumber) {
        product.bestSoldNumber = hit._source.bestSoldNumber;
    } else {
        product.bestSoldNumber = '';
    }
    if(hit._source.actionCategoryBtns) {
        product.actionCategoryBtns = hit._source.actionCategoryBtns;
    } else {
        product.actionCategoryBtns = '';
    }

    return product;
}

regularSearchHitProcessors.author = function(hit) {
    var author = {};
    author.urlFront = hit._source.urlFront;
    author.description = hit.highlight && hit.highlight.description ? hit.highlight.description : hit._source.description;

    return author;
}

regularSearchHitProcessors.publisher = function(hit) {
    var publisher = {};
    publisher.urlFront = hit._source.publisherUrl;
    publisher.description = hit._source.publisher;

    return publisher;
}

regularSearchHitProcessors.category = function(hit) {
    var category = {};
    category.urlFront = hit._source.urlFront;
    category.description = hit.highlight && hit.highlight.description ? hit.highlight.description : hit._source.description;

    return category;
}